module.exports = "<app-header></app-header>\r\n\r\n<router-outlet></router-outlet>\r\n\r\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// F:/Projects/tfs/VS2015/SolventC/SolventCWebsite/Angular4.Website/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main